import { createAuthClient } from './factories/amplify-auth-client';
import { AuthClient } from './types';

let singleton: AuthClient;

export const getAuthClient = async () => {
  if (!singleton) {
    singleton = await createAuthClient();
  }

  return singleton;
};
